export default {
    name: 'Burger',
    data () {
        return {
            closeBurgerMenu: false
        }
    },
    methods: {
        toggleBurger: function() {
            let burgerMenu = document.getElementById('burger-menu');
            //burgerMenu.classList.toggle("close");
            this.closeBurgerMenu = !this.closeBurgerMenu;
        }
    }
}